const faqs = [
  {
    question: '韩漫漫画网是什么？',
    answer: '韩漫漫画网是一个专注于韩国漫画（韩漫/Webtoon）推荐的中文平台。我们精心筛选和评测各类韩国漫画，涵盖恋爱、奇幻、动作、悬疑、搞笑、耽美、剧情、惊悚等多种类型，提供最新热门韩国漫画推荐和真实可靠的无删减韩国漫画排行榜，帮助您快速找到值得阅读的优质韩漫作品。',
  },
  {
    question: '网站上的漫画都是免费的吗？',
    answer: '韩漫漫画网本身是一个推荐和评测平台，我们提供详细的漫画介绍、评测和分类导航。读者可以通过我们提供的链接前往各大正版漫画平台进行阅读。我们推荐通过正规渠道支持您喜爱的漫画作者。',
  },
  {
    question: '如何找到自己喜欢的韩国漫画？',
    answer: '您可以通过多种方式在韩漫漫画网上找到心仪的漫画：使用顶部的分类导航按类型浏览；查看首页的热门排行榜了解当前最受欢迎的作品；浏览精选推荐区域发现编辑推荐的高质量漫画。每个漫画页面都提供了详细的介绍和评测，帮助您做出选择。',
  },
  {
    question: '网站多久更新一次内容？',
    answer: '韩漫漫画网每日更新！我们的编辑团队持续关注韩国漫画界的最新动态，及时更新漫画推荐、排行榜和评测内容。热门漫画的更新状态也会实时同步，确保您获取的信息始终是最新的。',
  },
  {
    question: '如何联系我们？',
    answer: '您可以通过以下方式联系韩漫漫画网：发送邮件至 contact@hanmancomic.com，或访问我们的"关于我们"页面获取更多联系方式。我们欢迎读者提供漫画推荐、反馈意见以及任何合作咨询。',
  },
];

export default function FAQSection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="mb-6 md:mb-8 text-center">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            关于韩漫漫画网，你想知道的都在这里
          </p>
        </div>
        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 text-sm md:text-base font-medium text-foreground-900 list-none">
                {faq.question}
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-lg" />
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}